import './heroSection.scss'

const HeroSection = ({children , chauffeurServicesPageLayout = false , customClassName= '' , eventsPageLayout}) => {
  return (
    <section className={`hero container grid ${eventsPageLayout ? 'grid-cols-1 md:grid-cols-12' : 'grid-cols-1 lg:grid-cols-12'} ${customClassName} ${chauffeurServicesPageLayout ? "px-[15px]" : ""}`}>
      {children}
    </section>
  )
}

export default HeroSection